import { Formik, Form, Field, ErrorMessage } from "formik";
import { useEffect, useState } from "react";
import * as yup from 'yup';
import { Box, CircularProgress } from "@mui/material";
import ListHeaderComponent from "../../../../components/OB/ListHeaderComponent";
import ResponsiveTabs from "../../../../components/OB/Tabbar";
import InsaatMaliyetBedelleri from "../../Tarifeler/EmlakVergisiTarifeleriTabs/InsaatMaliyetBedelleri";
import KatsayilarVeDegerlemeOrani from "../../Tarifeler/EmlakVergisiTarifeleriTabs/KatsayilarVeDegerlemeOrani";
import CevreTemizlikBildirim from "./CevreTemizlikBildirim";
import SessionStorageService from "../../../../services/StorageService";
import { useNavigate } from "react-router";
import EmlakBildirim from "./EmlakBildirim";
import IlanReklamBeyan from "./IlanReklamBeyan";
import KatiAtikBeyan from "./KatiAtikBeyan";
import EglenceBeyan from "./EglenceBeyan";
import AciklamaAndUserControlPopup from "../../../../components/OB/popups/aciklama-usercontrol-popup";


const BeyanlarBildirimler = () => {
  const [value, setValue] = useState(0);
  //Kullanıcı Login control ve yönlendirme
  let user = SessionStorageService.getUserInfo();
  const [userControlPopup, setUserControlPopup] = useState(false);
  const navigate = useNavigate();
  const closeUserControlPopup = () => {
    setUserControlPopup(false);
    navigate(-1);
  }
  const [isLoad, setIsLoad] = useState(true);
  useEffect(() => {

    if (user == null) {

      setUserControlPopup(true);
    } else {
      setIsLoad(false);
    }

  }, []);


  const handleChange = (event: any, newValue: any) => {
    setValue(newValue);
  };

  return (isLoad ? <>
    <div className="d-flex align-self-strech justify-content-center align-items-center"> <CircularProgress /></div>
    {userControlPopup ? (

      <AciklamaAndUserControlPopup
        open={userControlPopup}
        handleClose={closeUserControlPopup}
        isUserControlPopUp={true}
        description={"Bu sayfayı kullanmak için giriş yapmalısınız."}
      />

    ) : null}
  </> :
    <div>
      <ResponsiveTabs
        items={[
          { title: "Emlak Bildirim", onClick: () => console.log("Tab 1 clicked") },
          { title: "Çevre Temizlik Bildirim", onClick: () => console.log("Tab 2 clicked") },
          { title: "ilan Reklam Beyan", onClick: () => console.log("Tab 3 clicked") },
          { title: "Eğlence Beyan", onClick: () => console.log("Tab 4 clicked") },
          { title: "Katı Atık Beyan", onClick: () => console.log("Tab 5 clicked") },
        ]}
        value={value}
        onChange={handleChange}
        spreadWidth={true}
      />
      <div className=" pt-2 px-0 card w-100 mt-2">
      <div className="card-body px-xl-4 px-lg-3 px-md-2 px-sm-1">
        {value === 0 && <EmlakBildirim sicilKodu={user.sicilKodu} />}
        {value === 1 && <CevreTemizlikBildirim sicilKodu={user.sicilKodu} />}
        {value === 2 && <IlanReklamBeyan sicilKodu={user.sicilKodu} />}
        {value === 3 && <EglenceBeyan sicilKodu={user.sicilKodu} />}
        {value === 4 && <KatiAtikBeyan sicilKodu={user.sicilKodu} />}
        </div>
        </div>
    </div>
  );
};

export default BeyanlarBildirimler;